export const generateOnchainDescription = (
  title: string,
  description: string,
): string => {
  const markdownTitle = `# ${title}`

  return `${markdownTitle}\n${description}`
}
